import { Box, styled } from "@mui/material";


export const ProvidersMetricsFilterWrapper = styled(Box)({
    display: "flex",
    height: "100%",
    alignItems: "center",
    padding: "0 10px"
})